import { HttpErrorResponse } from "@angular/common/http";
import { inject, ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from 'angular-oauth2-oidc';
import { ApplicationInsightsService } from './appinsights.service';
//import { AppInsightsService } from "./appinsights.service";

@Injectable({
    "providedIn": "root"
})
export class PCPErrorHandler implements ErrorHandler {
    private router = inject(Router);
    private appInsightsService = inject(ApplicationInsightsService);
    private oAuthService = inject(OAuthService);

    handleError (error: any) {
        
        this.appInsightsService.logException(error);  
        console.log(error);  
        
        if (error instanceof HttpErrorResponse) {
            const httpError: HttpErrorResponse = error;

            if (httpError.status === 401) {        //401 - Unauthorized
                if (!this.oAuthService.hasValidAccessToken()) {
                    this.router.navigateByUrl("/unauthorized");
                }
            }
            else if (httpError.status === 403) {          //403 - Forbidden
                this.router.navigateByUrl("/forbidden");
            } else {
                //need to throw or the error will be lost
                throw error;
            }
        }

        //need to throw or the error will be lost
        throw error;
    }

}
